import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { PreviewFilesStateService } from "../../../../../../core/services/preview-files-state.service";
import { ImgSize } from "../../types/file-card.types";
import { defaultImgSize } from "../../configs/file-card-config";

@Component({
  selector: 'app-file-card-image',
  standalone: true,
  imports: [],
  templateUrl: './file-card-image.component.html',
  styleUrl: './file-card-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileCardImageComponent {
  fileId = input<number>(0);
  imgSize = input<ImgSize>(defaultImgSize);
  needBtn = input<boolean>(false);
  openPreview = output<void>();

  private previewFilesStateService: PreviewFilesStateService = inject(PreviewFilesStateService);

  public getUrl(): string {
    return this.previewFilesStateService.getFileUrl(this.fileId());
  }

  public handleClick(): void {
    this.openPreview.emit();
  }
}
